import { DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  Grid,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import TableLoader from "components/common/TableLoader/TableLoader";
import CustomInput from "components/common/customInput/CustomInput";
import { FieldArray } from "formik";
import { FaPlus } from "react-icons/fa";

const TabForm = ({ activePage, setFieldValue, values, isDisabled }: any) => {
  return (
    <Box display={activePage === 7 ? undefined : "none"} mt={2}>
      <Flex justify={"space-between"} mb={4} align={"end"}>
        <Flex alignItems="end" gap={4}>
          <Text whiteSpace={"nowrap"} fontWeight="500">
            Show Onboarding Tab:
          </Text>
          <CustomInput
            disabled={isDisabled}
            type="switch"
            value={values.onboarding}
            name="onboarding"
            onChange={(e: any) => setFieldValue(`onboarding`, e.target.checked)}
          />
        </Flex>
        <Flex>
          <Tooltip label="Add Tab" hasArrow>
            <Button
              size="sm"
              onClick={() =>
                setFieldValue(`tab`, [
                  ...values.tab,
                  { isActive: false, url: "", label: "", icon: "" },
                ])
              }
              bg="teal.400"
              color="white"
              _hover={{ bg: "teal.500" }}
              disabled={isDisabled}
            >
              <FaPlus />
            </Button>
          </Tooltip>
        </Flex>
      </Flex>

      <Box>
        <Table variant="striped" size="sm">
          <Thead>
            <Tr>
              <Th>Show Tab</Th>
              <Th>URL</Th>
              <Th>Label</Th>
              <Th>Icon</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <FieldArray name="tab">
            {({ remove }) => (
              <TableLoader loader={false} show={values?.tab}>
                <Tbody>
                  {Array.isArray(values?.tab) &&
                    values?.tab?.map((item: any, indexKey: any) => (
                      <Tr key={indexKey}>
                        {/* Is Active Switch */}
                        <Td>
                          <CustomInput
                            disabled={isDisabled}
                            type="switch"
                            name={`tab[${indexKey}].isActive`}
                            value={values?.tab[indexKey]?.isActive}
                            onChange={(e: any) =>
                              setFieldValue(
                                `tab[${indexKey}].isActive`,
                                e.target.checked
                              )
                            }
                          />
                        </Td>

                        {/* URL Input */}
                        <Td>
                          <Input
                            size="sm"
                            placeholder="Enter URL"
                            value={values?.tab[indexKey]?.url}
                            onChange={(e) =>
                              setFieldValue(
                                `tab[${indexKey}].url`,
                                e.target.value
                              )
                            }
                            disabled={isDisabled}
                          />
                        </Td>

                        {/* Label Input */}
                        <Td>
                          <Input
                            size="sm"
                            placeholder="Enter Label"
                            value={values?.tab[indexKey]?.label}
                            onChange={(e) =>
                              setFieldValue(
                                `tab[${indexKey}].label`,
                                e.target.value
                              )
                            }
                            disabled={isDisabled}
                          />
                        </Td>

                        {/* Icon Input */}
                        <Td>
                          <Input
                            size="sm"
                            placeholder="Enter Icon Name"
                            value={values?.tab[indexKey]?.icon}
                            onChange={(e) =>
                              setFieldValue(
                                `tab[${indexKey}].icon`,
                                e.target.value
                              )
                            }
                            disabled={isDisabled}
                          />
                        </Td>

                        {/* Delete Button */}
                        <Td>
                          <Tooltip label="Delete Tab" hasArrow>
                            <Button
                              size="sm"
                              colorScheme="red"
                              variant="outline"
                              onClick={() => remove(indexKey)}
                              disabled={isDisabled}
                            >
                              <DeleteIcon />
                            </Button>
                          </Tooltip>
                        </Td>
                      </Tr>
                    ))}
                </Tbody>
              </TableLoader>
            )}
          </FieldArray>
        </Table>
      </Box>
    </Box>
  );
};

export default TabForm;
